import { Box, Typography, IconButton, Tooltip } from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'

async function copyArticleCode(value) {
  if (!value || value === 'N/A') return
  try {
    await navigator.clipboard.writeText(String(value))
  } catch (err) {
    console.error('Failed to copy article code:', err)
  }
}

function ArticleCodeCell({ articleCode }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {articleCode || 'N/A'}
      </Typography>
      {articleCode && articleCode !== 'N/A' && (
        <Tooltip title="Copy article code">
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation()
              copyArticleCode(articleCode)
            }}
          >
            <ContentCopyIcon sx={{ fontSize: 14 }} />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  )
}

export default ArticleCodeCell
